import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_DISTRICT_USERS_REQUEST,
  FETCH_DISTRICT_USERS_SUCCESS,
  FETCH_DISTRICT_USERS_FAILURE,
  FETCH_DISTRICT_TASK_SUBMIT_REQUEST,
  FETCH_DISTRICT_TASK_SUBMIT_SUCCESS,
  FETCH_DISTRICT_TASK_SUBMIT_FAILURE,
} from "../actions/dashboardActions";

const initialState = {
  stats: {},
  districtUsers: [],
  districtTaskSubmit: [],
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
    case FETCH_DISTRICT_USERS_REQUEST:
    case FETCH_DISTRICT_TASK_SUBMIT_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };

    case FETCH_DISTRICT_USERS_SUCCESS:
      return { ...state, loading: false, districtUsers: action.payload };

    case FETCH_DISTRICT_TASK_SUBMIT_SUCCESS:
      return { ...state, loading: false, districtTaskSubmit: action.payload };

    case FETCH_DASHBOARD_STATS_FAILURE:
    case FETCH_DISTRICT_USERS_FAILURE:
    case FETCH_DISTRICT_TASK_SUBMIT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default dashboardReducer;
